// extracted by mini-css-extract-plugin
export default {"left":"style_left__+i-zv","right":"style_right__NWYa2","rightIcon":"style_rightIcon__aOxs8","bold":"style_bold__JwmZh"};